const path = require('path')

module.exports = {
  i18n: {
    locales: ['default', 'nl', 'fr'],
    defaultLocale: 'default'
  },
  localeDetection: false,
  localePath: path.resolve('./public/translations')
}
